import { Box } from '@mui/material'
import { ReactNode } from 'react'

import { theme } from '@maersktankersdigital/web-components'
import styled from 'styled-components/macro'

export const DeprecatedStyledWrapper = styled.div`
  position: relative;
  margin: 0 auto;
  padding: 0 16px;

  @media only screen and (${theme.BREAKPOINTS.sm}) {
    padding: 0 56px;
  }

  @media only screen and (${theme.BREAKPOINTS.xxl}) {
    padding: 0 152px;
  }
`

export const StyledWrapper = ({ children }: { children: ReactNode }) => (
  <Box
    sx={{
      position: 'relative',
      margin: '0 16px',
      // border: '1px solid red',
      '@media only screen and (min-width: 600px)': {
        margin: '0 96px',
      },
      '@media only screen and (min-width: 1920px)': {
        margin: '0 96px',
      },
    }}
  >
    {children}
  </Box>
)
